<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'app',
  beforeCreate() {
    // window.location = '/static/default.html?v=' + new Date().getUTCSeconds()
    // window.reload()
    // var user = api.storage.get('user')
    // if (user === null) {
    //   window.location = '/default.html?v=' + new Date().getUTCSeconds()
    //   window.reload()
    // }
  },
}
</script>



// WEBPACK FOOTER //
// App.vue?3e0d6959